/*! @azure/msal-common v16.5.1 2026-04-21 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.5.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
